<template>
  <select id="sourceSelect" :value="modelValue" @change="onChange" class="form-select">
    <option :disabled="!props.enabled" value="">{{ props.enabled ? `Show All Sources` : '--- No source selected ---'}}</option>
    <option v-if="props.enabled" value="0">Missing Source</option>
    <optgroup
        v-for="category in sourceCategories"
        :key="category.id"
        :label="category.name"
    >
      <option
          v-for="child in category.subcategories"
          :key="child.id"
          :value="child.id"
      >
        {{ child.name }}
      </option>
    </optgroup>
  </select>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  enabled: {
    type: Boolean,
    default: false
  }
})

const sourceCategories = computed(() => store.state.eshop.sourceCategories)

// Define the emit event for v-model binding
const emit = defineEmits(['update:modelValue'])

function onChange(event) {
  emit('update:modelValue', event.target.value)
}
</script>
